export const normalizeResponsibilitySuggestions = (results, cleanText) => {
  if (!Array.isArray(results)) return [];

  const seen = new Set();
  const suggestions = results.reduce((normalized, item) => {
    const text = cleanText(item?.enhancement || '').trim();
    const key = text.toLowerCase();
    if (!text || seen.has(key)) return normalized;
    seen.add(key);
    normalized.push({
      text,
      keywordMetadata: {
        term: item?.keywordMetadata?.term || item?.skill || '',
        category: item?.keywordMetadata?.category || 'transferable',
        intent: item?.keywordMetadata?.intent || '',
      },
    });
    return normalized;
  }, []);

  const categoryOrder = { verified: 0, aligned: 1, transferable: 2 };
  const categoryCounts = { verified: 0, aligned: 0, transferable: 0 };
  return suggestions
    .sort((left, right) => (
      (categoryOrder[left.keywordMetadata.category] ?? 2)
      - (categoryOrder[right.keywordMetadata.category] ?? 2)
    ))
    .filter((suggestion) => {
      const category = categoryOrder[suggestion.keywordMetadata.category] === undefined
        ? 'transferable'
        : suggestion.keywordMetadata.category;
      if (categoryCounts[category] >= 5) return false;
      categoryCounts[category] += 1;
      return true;
    });
};

export const splitHighlightedText = (text, term) => {
  const value = String(text || '');
  const keyword = String(term || '').trim();
  if (!keyword) return [{ text: value, highlighted: false }];

  const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escaped})`, 'gi');
  return value.split(regex).filter(Boolean).map((part) => ({
    text: part,
    highlighted: part.toLowerCase() === keyword.toLowerCase(),
  }));
};
